(() => {

class AnnouncementBar extends HTMLElement {
  #timer = undefined;
  #current = 0;
  #slyde = null;
  #slides = null;

  connectedCallback() {
    const mode = this.getAttribute('mode');

    switch (mode) {
      case 'marquee':
        this.#initMarquee();
        break;
      case 'slideshow':
        this.#initSlideshow();
        break;
      case 'fade':
      case 'slide-down':
        this.#initRotation();
        break;
    }

    document.addEventListener('visibilitychange', this.#onVisibility);
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
    if (this.#slyde) {
      this.#slyde.destroy();
      this.#slyde = null;
    }
    document.removeEventListener('visibilitychange', this.#onVisibility);
  }

  // ---- Marquee ----

  #initMarquee() {
    const content = this.querySelector('.lh-announcement-bar__content');
    const track = this.querySelector('.lh-announcement-bar__track');
    if (!content || !track) return;

    const w = content.offsetWidth;
    if (w === 0) return;

    const copies = Math.max(1, Math.ceil((window.innerWidth * 2) / w));
    for (let i = 0; i < copies; i++) {
      const clone = content.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }

    track.style.setProperty('--marquee-offset', `-${w}px`);
  }

  // ---- Slideshow (Slyde) ----

  #initSlideshow() {
    const { Slyde, Autoplay } = window.Slyde || {};
    if (!Slyde) return;

    const wrapper = this.querySelector('.slyde-wrapper');
    if (!wrapper || wrapper.children.length <= 1) return;

    const autoplay = this.hasAttribute('autoplay');
    const delay = this.#ms();
    const modules = autoplay && Autoplay ? [Autoplay] : [];

    requestAnimationFrame(() => {
      this.#slyde = new Slyde(this, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: false,
        pagination: false,
        thumbnails: false,
        video: false,
        freeMode: false,
        autoplay: autoplay ? { delay, pauseOnHover: true } : false,
        modules,
      });
    });
  }

  // ---- Fade / Slide-down ----

  #initRotation() {
    this.#slides = this.querySelectorAll('.lh-announcement-bar__slide');
    if (this.#slides.length <= 1) return;

    if (this.hasAttribute('autoplay')) {
      this.#timer = setInterval(() => this.#nextRotation(), this.#ms());
    }
  }

  #nextRotation() {
    const prev = this.#current;
    this.#current = (this.#current + 1) % this.#slides.length;
    const mode = this.getAttribute('mode');

    if (mode === 'slide-down') {
      this.#slides[prev].classList.add('is-exiting');
      this.#slides[prev].classList.remove('is-active');
      setTimeout(() => this.#slides[prev].classList.remove('is-exiting'), 400);
    } else {
      this.#slides[prev].classList.remove('is-active');
    }

    this.#slides[this.#current].classList.add('is-active');
  }

  // ---- Helpers ----

  #ms() {
    return (parseInt(this.getAttribute('interval'), 10) || 5) * 1000;
  }

  #onVisibility = () => {
    if (!this.hasAttribute('autoplay')) return;
    const mode = this.getAttribute('mode');
    if (mode === 'marquee' || mode === 'slideshow') return;

    if (document.hidden) {
      clearInterval(this.#timer);
      this.#timer = undefined;
    } else if (!this.#timer) {
      this.#timer = setInterval(() => this.#nextRotation(), this.#ms());
    }
  };
}

if (!customElements.get('lh-announcement-bar')) {
  customElements.define('lh-announcement-bar', AnnouncementBar);
}

})();
